import { useState } from "react";
import WorkspaceShell from "@/components/WorkspaceShell";
import ChatPane from "@/components/ChatPane";
import MarketsPanel from "@/components/falcon/MarketsPanel";
import NewsPanel from "@/components/falcon/NewsPanel";
import FilingsPanel from "@/components/falcon/FilingsPanel";
import AnalysisPanel from "@/components/falcon/AnalysisPanel";
import MessengerPanel from "@/components/falcon/MessengerPanel";
import { productByKey } from "@/lib/products";
import { Activity, MessageSquare, Newspaper, FileText, Calculator, Users } from "lucide-react";

const PRODUCT = productByKey("falcon");

const STARTERS = [
  "Impact of a Saudi rate hike on Gulf bank stocks over the next 6 months?",
  "Compare Naira vs Kenyan Shilling outlook for Q3 2026",
  "What are the top 3 risks for African telcos in 2026?",
  "Summarize ADNOC's latest earnings and implications for energy ETFs",
];

const TABS = [
  { key: "chat",      label: "Analyst chat", icon: MessageSquare },
  { key: "markets",   label: "Markets",       icon: Activity },
  { key: "news",      label: "News",          icon: Newspaper },
  { key: "filings",   label: "Filings",       icon: FileText },
  { key: "analysis",  label: "Analysis",      icon: Calculator },
  { key: "messenger", label: "Messenger",     icon: Users },
];

export default function Falcon() {
  const [bump, setBump] = useState(0);
  const [tab, setTab] = useState("chat");

  return (
    <WorkspaceShell product={PRODUCT} usageRefresh={bump}>
      <div className="space-y-5">
        {/* Tab bar */}
        <div className="flex gap-2 overflow-x-auto pb-1 -mx-1 px-1">
          {TABS.map((t) => {
            const Icon = t.icon;
            const active = tab === t.key;
            return (
              <button key={t.key} data-testid={`falcon-tab-${t.key}`} onClick={() => setTab(t.key)}
                className={`shrink-0 inline-flex items-center gap-2 h-10 px-4 rounded-sm border text-sm font-medium transition-colors ${
                  active ? "border-foreground bg-card" : "border-border/60 bg-card/40 text-muted-foreground hover:text-foreground"
                }`}
                style={active ? { borderColor: PRODUCT.accent } : undefined}>
                <Icon className="h-4 w-4" />
                {t.label}
              </button>
            );
          })}
        </div>

        {tab === "chat" && (
          <ChatPane
            product={PRODUCT}
            endpoint="/falcon/chat"
            accent={PRODUCT.accent}
            placeholder="Ask Falcon a financial question…"
            starters={STARTERS}
            stream
            streamProduct="falcon"
            onSent={() => setBump((n) => n + 1)}
          />
        )}
        {tab === "markets"   && <MarketsPanel   accent={PRODUCT.accent} />}
        {tab === "news"      && <NewsPanel      accent={PRODUCT.accent} />}
        {tab === "filings"   && <FilingsPanel   accent={PRODUCT.accent} />}
        {tab === "analysis"  && <AnalysisPanel  accent={PRODUCT.accent} />}
        {tab === "messenger" && <MessengerPanel accent={PRODUCT.accent} />}
      </div>
    </WorkspaceShell>
  );
}
